<div class="dashboard h-100">
    <div class="dashboard-card no-padding d-flex flex-column justify-content-between"
        style="max-width: 800px">
        <div class="row">
            <div class="col-12">
                <div class=" d-flex flex-column  padding-container">
                    <h2 class="card-dash-title">Documentos</h2>
                </div>
            </div>

            <div class="col-12 dashboard-card-body">
                <ng-container *ngIf="loading">
                    <table #table>
                        <tbody>
                            <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                                <td>
                                    <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '200px',
                                    marginBottom:'0'                            
                                      }">
                                    </ngx-skeleton-loader>
                                </td>
                                <td class="item-number">
                                    <ngx-skeleton-loader [theme]="{
                                    height: '16px',
                                    width: '40px',
                                    marginBottom:'0',
                                    marginLeft: 'auto'
                                  }">
                                    </ngx-skeleton-loader>
                                </td>
                                <td>
                                    <div
                                        style="display: flex; gap: 16px; justify-content: flex-end;">
                                        <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '16px',
                                            marginBottom:'0',
                                            borderRadius: '0'
                                          }">
                                        </ngx-skeleton-loader>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </ng-container>

                <table *ngIf="!loading && documents.length > 0"
                    class="bordered">
                    <thead>
                        <tr>
                            <th>Documentos</th>
                            <th style="text-align:right;">Qtde. de Vínculos</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let document of visible_documents">
                            <td class="doc-item"
                                [style.max-width.px]="tableSize"
                                style="width: 100%;">
                                {{document.name}}</td>
                            <td style="text-align:right;">
                                {{document.roles.length}}
                            </td>
                            <td>
                                <div class="table-options">
                                    <app-tooltip text="Excluir"
                                        *ngIf="permissionObj.canDelete">
                                        <button
                                            (click)="openDeleteModal(document)">
                                            <svg-icon
                                                src="assets/images/icon-trash.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                    <app-spacer [right]="19"></app-spacer>
                                    <app-tooltip text="Editar"
                                        *ngIf="permissionObj.canChange">
                                        <button (click)="setDocument(document)">
                                            <svg-icon
                                                src="assets/images/icon-edit.svg"></svg-icon>
                                        </button>
                                    </app-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-12">
                <div class="padding-container d-flex flex-row justify-content-between"
                    *ngIf="loading || documents.length > 0">
                    <app-button [inverted]="true"
                        (onClick)="redirect('/app/settings/documents')">
                        Ver todos
                    </app-button>

                    <app-button (click)="addDocumentsToggle(true)"
                        class="add-button" [disabled]="loading"
                        *ngIf="permissionObj.canAdd">
                        <svg-icon src="assets/images/icon-add.svg"
                            class="mr-2 mt-1 mb-1"></svg-icon>Adicionar
                        documento</app-button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 " *ngIf="documents.length === 0 && !loading">
                <div class="empty-card">
                    <div class="img-container">
                        <img src="/assets/images/documents-icon.png"
                            alt="icone">
                    </div>

                    <ng-container *ngIf="!permissionObj.canAdd">
                        <h3>
                            Ainda não existem documentos cadastrados
                        </h3>
                    </ng-container>

                    <ng-container *ngIf="!permissionObj.canAdd">
                        <h3>Defina os documentos</h3>
                        <p>
                            Curabitur maximus ipsum non quam bibendum facilisis.
                            Ut
                            sollicitudin id erat vel
                        </p>

                        <app-button (click)="addDocumentsToggle(true)"
                            class="add-button">
                            <svg-icon src="assets/images/icon-add.svg"
                                class="mr-2"></svg-icon>Adicionar
                            documento
                        </app-button>
                    </ng-container>
                </div>
            </div>
        </div>
    </div>
</div>

<app-side-modal [active]="addDocuments" (onClose)="closeModal()"
    [title]="document ? 'Atualizar documento' : 'Adicionar documento'"
    paddingBottom="30">
    <ng-container *ngIf="addDocuments">
        <div class="row align-items-center" [formGroup]="documentsForm">
            <div class="col-12">
                <app-input label="Nome do documento" [group]="documentsForm"
                    controlName="name" helpText="Máximo de 100 caracteres"
                    [maxLength]="100">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-input label="Descrição" [rows]="3" [group]="documentsForm"
                    controlName="description"
                    helpText="Máximo de 900 caracteres" [maxLength]="900">
                </app-input>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-select [items]="agentsOptions" [multiple]="true"
                    label="Defina para quais agentes este documento deve ser solicitado"
                    [group]="documentsForm" controlName="roles">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12" *ngIf="showFrameworks">
                <div style="margin-bottom: 12px;">
                    <app-radio [multiple]="true"
                        [isChecked]="allFrameworksSelected"
                        (onCheckChanged)="toggleAllFrameworks($event)">
                        <span class="app-radio-text">Todos os
                            enquadramentos</span>
                    </app-radio>
                </div>
                <app-select [items]="frameworkList" [multiple]="true"
                    label="Defina o enquadramento da empresa"
                    [group]="documentsForm" controlName="frameworks"
                    [readOnly]="disableFrameworksSelect"
                    [disabled]="disableFrameworksSelect">
                </app-select>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12">
                <app-radio [multiple]="true" formControlName="required">
                    <span class="app-radio-text">Preenchimento
                        obrigatório</span>
                </app-radio>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-radio [multiple]="true" formControlName="have_due_date">
                    <span class="app-radio-text">Possui data de validade</span>
                </app-radio>
                <app-spacer [bottom]="16"></app-spacer>
            </div>

            <div class="col-12">
                <app-radio [multiple]="true" formControlName="individual"
                    [disabled]="disableIndividual">
                    <span class="app-radio-text">Solicitar individualmente para
                        cada pessoa física</span>
                </app-radio>
                <app-spacer [bottom]="24"></app-spacer>
            </div>

            <div class="col-12 col-lg-6">
            </div>

            <div class=" col-12 col-lg-6 text-right">
                <app-button [disabled]="documentsForm.invalid"
                    (click)="addDocument()">
                    {{document ? 'Atualizar documento' : 'Adicionar documento'}}
                </app-button>
            </div>
        </div>
    </ng-container>

</app-side-modal>

<!-- Carbon Warning Modals -->
<app-carbon-warning-modal [active]="showDeleteModal"
    [title]="getDeleteModalTitle()" [message]="getDeleteModalMessage()"
    [confirmText]="getDeleteConfirmText()" [cancelText]="getDeleteCancelText()"
    [confirmAction]="confirmDeleteDocument.bind(this)"
    [cancelAction]="closeDeleteModal.bind(this)" (onClose)="closeDeleteModal()">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showSuccessModal"
    [title]="getSuccessModalTitle()" [message]="getSuccessModalMessage()"
    [confirmText]="getSuccessConfirmText()" [cancelText]="''"
    [confirmAction]="closeSuccessModal.bind(this)"
    [cancelAction]="closeSuccessModal.bind(this)"
    (onClose)="closeSuccessModal()">
</app-carbon-warning-modal>

<app-carbon-warning-modal [active]="showErrorModal"
    [title]="getErrorModalTitle()" [message]="getErrorModalMessage()"
    [confirmText]="getErrorConfirmText()" [cancelText]="''"
    [confirmAction]="closeErrorModal.bind(this)"
    [cancelAction]="closeErrorModal.bind(this)" (onClose)="closeErrorModal()">
</app-carbon-warning-modal>